import { render, staticRenderFns } from "./lxcs.vue?vue&type=template&id=014c16f1&scoped=true"
import script from "./lxcs.vue?vue&type=script&lang=js"
export * from "./lxcs.vue?vue&type=script&lang=js"
import style0 from "./lxcs.vue?vue&type=style&index=0&id=014c16f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014c16f1",
  null
  
)

export default component.exports